import { createContext, useContext, useEffect, useState } from "react";
import { getSettings } from "../lib/api";

const SiteContext = createContext({ settings: null, loading: true });

export const useSite = () => useContext(SiteContext);

export const SiteProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getSettings()
      .then(setSettings)
      .catch(() => setSettings(null))
      .finally(() => setLoading(false));
  }, []);

  // Dynamic favicon from settings (supports uploaded /api/media/... paths)
  useEffect(() => {
    if (!settings?.favicon_path) return;
    const link = document.querySelector('link[rel="icon"]');
    if (link) link.href = settings.favicon_path;
  }, [settings?.favicon_path]);

  return (
    <SiteContext.Provider value={{ settings, loading }}>
      {children}
    </SiteContext.Provider>
  );
};
